<script setup lang="ts">
import type { IAoeCartEarnedDiscount } from '@/types/CartTypes.ts'
import { SvgIcon } from '@progress/kendo-vue-common'
import { checkOutlineIcon } from '@progress/kendo-svg-icons'

const props = defineProps<{
  earnedDiscount: IAoeCartEarnedDiscount
}>()
</script>

<template>
  <div class="coupon-award">
    <div
      v-if="
        props.earnedDiscount.freeDollarsCost == null ||
        props.earnedDiscount.freeDollarsCost == 0
      "
      class="row coupon-row"
    >
      <div class="col-1 coupon-check">
        <SvgIcon class="check-mark-outline-icon" :icon="checkOutlineIcon">
        </SvgIcon>
      </div>
      <div
        class="col-2 discountMessage coupon-message"
        v-html="props.earnedDiscount.awardMessage"
      ></div>
    </div>
  </div>
</template>

<style lang="scss">
.percentage-off-item-chosen-check,
.percentage-off-item-message,
.percentage-off-item-chosen-image,
.percentage-off-item-chosen-name,
.percentage-off-item-chosen-delete {
  align-content: center;
}

.percentage-off-item-chosen-delete {
  text-align: right;
}

.strike-through {
  text-decoration: line-through;
}

.cart-item-retail-price,
.cart-item-price {
  margin-left: 20px;
}

.unused-percent-off-item-divider {
  margin-bottom: 1rem !important;
}
</style>
